import {
  UNVERIFIED_ADMIN,
  UNVERIFIED_PURCHASER,
  UNVERIFIED_DIY,
  VERIFIED_ADMIN,
  VERIFIED_PURCHASER,
  VERIFIED_USER,
  ROUTES,
} from '../constants/constants';

export const getSvocId = () => {
  if (typeof window !== 'undefined' && window?.THDCustomer) {
    return (
      typeof window !== 'undefined' && window?.THDCustomer?.default?.svocID
    );
  }
  if (typeof window !== 'undefined' && window?.THD_USER_SESSION) {
    return (
      typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.svocID
    );
  }
  return null; // '041FBEB7EE53EAF20S';
};

export const getUserId = () => {
  if (typeof window !== 'undefined' && window?.THDCustomer) {
    return (
      typeof window !== 'undefined' && window?.THDCustomer?.default?.userID
    );
  }
  if (typeof window !== 'undefined' && window?.THD_USER_SESSION) {
    return (
      typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.userID
    );
  }
  return null; // '041FBEB7EE69EAF20U';
};

export const isB2BUser = () => {
  return (
    typeof window !== 'undefined' && window?.THDCustomer?.default?.isB2BCustomer
  );
};

export const getHost = () => {
  return window.location.hostname;
};

export const isB2Badmin = () => {
  return (
    typeof window !== 'undefined' &&
    window?.THDCustomer?.default?.role === 'ADMIN'
  );
};

export const userRole = () => {
  if (window?.THDCustomer?.default?.role === 'ADMIN') {
    return 'Admin';
  }
  if (window?.THDCustomer?.default?.role === 'PURCHASER') {
    return 'Purchaser';
  }
  return null;
};

export const getUserEmail = () => {
  return typeof window !== 'undefined' && window?.THDCustomer?.default?.email;
};

export const defineUserType = (isB2B, isAdmin, isEnrolled) => {
  if (isB2B && !isAdmin && !isEnrolled) {
    return UNVERIFIED_PURCHASER;
  }
  if (isB2B && isAdmin && !isEnrolled) {
    return UNVERIFIED_ADMIN;
  }
  if (!isB2B && !isEnrolled) {
    return UNVERIFIED_DIY;
  }
  if (isB2B && isEnrolled && !isAdmin) {
    return VERIFIED_PURCHASER;
  }
  if (isB2B && isEnrolled && isAdmin) {
    return VERIFIED_ADMIN;
  }
  if (!isB2B && isEnrolled) {
    return VERIFIED_USER;
  }
  return UNVERIFIED_DIY;
};

export const getAuthorizationToken = () => {
  if (typeof window !== 'undefined' && window?.THDCustomer) {
    return typeof window !== 'undefined' && window?.THDCustomer?.default?.jwt;
  }
  if (
    typeof window !== 'undefined' &&
    window?.THD_USER_SESSION &&
    window?.THD_USER
  ) {
    return (
      typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.jwt
    );
  }
  return null;
};

/* Anchor for an FAQ section heading, derived from the heading itself. The
/* sections are ordered differently for enrolled and unenrolled customers, so
/* anything positional - like the accordion ids, which are built from the render
/* index - would point at a different section depending on who is reading. */
export const faqSectionId = (title) =>
  `faq-${String(title)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')}`;

/* The `code`/`state` pair ID.me leaves on the callback, as the raw `key=value`
/* text it arrived as, or '' on an ordinary page load. Filtered by literal key
/* rather than round-tripped through `URLSearchParams#toString()`, which
/* re-encodes every value under form-urlencoded rules (`%2B` becomes `+`, `~`
/* becomes `%7E`, ...). The BFF seals `state` and replays `code` at token
/* exchange, so both have to survive byte for byte. */
const idmeCallbackQuery = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.search
    .replace(/^\?/, '')
    .split('&')
    .filter((entry) => {
      const key = entry.split('=', 1)[0];
      return key === 'code' || key === 'state';
    })
    .join('&');
};

/* The sign-in URL, carrying an in-flight ID.me verification back with it. A
/* customer whose session lapsed while they were away at ID.me returns to a
/* callback URL; sending them to sign in without `code`/`state` would strand the
/* verification they just earned and make them start over. The military
/* verification component deliberately leaves the pair on the URL when it finds
/* no session to exchange against, waiting for them to come back with it intact.
/*
/* Only those two params are carried - anything else on the query string is
/* dropped, so an ordinary expired-session visit lands back exactly where it
/* does today. The whole return address is encoded once, as a single `redirect`
/* value, so the sign-in page hands back the query string rather than reading it
/* as its own.
/*
/* Split from the navigation below so the address can be asserted on: jsdom
/* seals `window.location`, leaving no way to observe a `replace` call. */
export const signInRedirectUrl = () => {
  const query = idmeCallbackQuery();
  const target = `${ROUTES.landing.url}${query ? `?${query}` : ''}`;
  return `/auth/view/signin?redirect=${encodeURIComponent(target)}`;
};

export const redirectToSignIn = () => {
  window.location.replace(signInRedirectUrl());
};

export const redirectToLearnMore = () => {
  window.location.href = 'http://www.homedepot.com/c/military/';
};
